/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import * as _ from 'lodash-es';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

angular.module('ticketspaceApp').factory('watcherStore', [
	'$rootScope',
	function ($rootScope) {
		const logger = LoggerServiceFactory.create('watcherStore');
		//private
		let simpleList = [];
		let keyedList = {};

		function reset() {
			logger.log('lag watcherStore reset', simpleList, keyedList);
			for (let i = 0; i < simpleList.length; i++) {
				simpleList[i]();
			}
			simpleList = [];

			for (let key in keyedList) {
				keyedList[key]();
			}
			keyedList = {};
			logger.log('lag watcherStore reset 2', simpleList, keyedList);
		}

		function push(watch, key) {
			if (typeof watch === 'function') {
				if (key) {
					keyedList[key] = watch;
				} else {
					simpleList.push(watch);
				}
			}
		}

		return {
			push,
			reset,
		};
	},
]);
